module.exports = __webpack_public_path__ + "assets/img/block-right-d0774d68.png";